import React, { useEffect } from "react";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Seo from "../components/common/seo";
import AllProjects from "../components/projects/allProjects";

import { projectListSchema } from "../data/schema";

import "./styles/projects.css";

const Projects = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<React.Fragment>
			<Seo page="projects" schema={projectListSchema} />

			<div className="page-content">
				<NavBar active="projects" />
				<div className="content-wrapper">
					<div className="projects-logo-container">
						<div className="projects-logo">
							<Logo width={46} />
						</div>
					</div>
					<main className="projects-container">
						<h1 className="title projects-title">
							Selected full-stack work built for scale,
							performance, and automation.
						</h1>

						<div className="subtitle projects-subtitle">
							These projects summarize the kind of problems I
							solve: high-volume workflows, faster production
							applications, and automation that removes repetitive
							manual work. I keep the focus on clear architecture,
							reliable delivery, and measurable outcomes.
						</div>

						<div className="projects-list">
							<AllProjects />
						</div>
					</main>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
